import Vue from 'vue';

const CH_SITE_HANDLES = [
    'mgMotorsSwitzerlandDe',
    'mgMotorsSwitzerlandFr',
    'mgMotorsSwitzerlandIt',
];

// Per-market overrides for the model-switcher thumbnail filename.
// Keyed by commerce handle; the override filename is used only on the listed
// site handles, all other markets keep the default `<commerceHandle>.png`.
const MODEL_SWITCH_FILE_OVERRIDES = {
    'mg3-ice-2024': {
        siteHandles: CH_SITE_HANDLES,
        fileName: 'mg3-ice-2024-silver',
    },
};

Vue.component('configurator-model-select', {
    props: {
        cdnUrl: {
            type: String,
            required: false,
        },
        siteHandle: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            selectionExpanded: false,
        };
    },

    computed: {
        makeBoxModelActive() {
            return this.selectionExpanded ? 'active' : '';
        },
    },

    methods: {
        selectModel(car) {
            this.$parent.handleSelectModel(car.slug);
        },

        getModelSelectTitle(selectedModel) {
            const isHs = ['hs', 'mg-hs-2023'].includes(selectedModel);
            const isMgStartOfName =
                selectedModel.title.slice(0, 2).toLowerCase() === 'mg';

            if (this.siteHandle === 'mgMotorsSpain' && isHs) {
                return 'Nuevo MG HS';
            }
            return isMgStartOfName
                ? selectedModel.title
                : `MG ${selectedModel.title}`;
        },

        getModelName(carTitle) {
            const slicedCarTitle = carTitle.slice(0, 2).toUpperCase();
            const hasNumber = carTitle.match(/\d+/);
            if (hasNumber != null) {
                return {
                    modelTitle: slicedCarTitle,
                    modelNumber: carTitle[2],
                };
            }

            return {
                modelTitle: `MG ${carTitle}`,
                modelNumber: '',
            };
        },

        getModelSwitchFileName(carCommerceHandle) {
            const override = MODEL_SWITCH_FILE_OVERRIDES[carCommerceHandle];
            if (!override) return carCommerceHandle;
            if (!override.siteHandles.includes(this.siteHandle)) {
                return carCommerceHandle;
            }
            return override.fileName;
        },

        getImagePath(carCommerceHandle) {
            const fileName = this.getModelSwitchFileName(carCommerceHandle);
            return `${this.cdnUrl}/images/configurator/model-switch/${fileName}.png`;
        },
    },
});
